<template>
  <div>
    <a-tag
      :key="tag"
      type="Info"
      v-for="tag in dynamicTags"
      closable
      effect="dark"
      :disable-transitions="false"
      @close="handleClose(tag)">
      {{tag}}
    </a-tag>
    <a-input
      class="input-new-tag"
      v-if="inputVisible"
      v-model="inputValue"
      ref="saveTagInput"
      @keyup.enter.native="handleInputConfirm"
      @blur="handleInputConfirm"
    >
    </a-input>
    <a-button v-else class="button-new-tag" @click="showInput">+</a-button>
  </div>
</template>

<script>
export default {
  name: 'MultiTagEditor',
  props: {
    value: Array,
  },
  data() {
    return {
      dynamicTags: this.value || [],
      inputVisible: false,
      inputValue: '',
    };
  },
  watch: {
    value(val) {
      this.dynamicTags = val;
    },
  },
  methods: {
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      this.$emit('input', this.dynamicTags);
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      if (this.dynamicTags.includes(this.inputValue)) {
        this.inputVisible = false;
        this.inputValue = '';
      }
      if (this.inputValue) {
        this.dynamicTags.push(this.inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
      this.$emit('input', this.dynamicTags);
    },
  },
};
</script>

<style scoped>
  .el-tag + .el-tag {
    margin-left: 10px;
  }

  .button-new-tag {
    margin-left: 10px;
    height: 20px;
    padding-top: 0;
    padding-bottom: 0;
  }

  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
</style>
